import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import { getCookieValue } from 'utils/cookies';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getCookieValue('lang'),
    debug: true,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });
